import { Modal } from 'components';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import modernist from './modernistTheme';
import { Live, PostDetails, Shoutout } from './screens';

const Card = styled.div`
  width: 100%;
  max-width: 1000px;
  max-height: 90vh;
  overflow-y: auto;
  background: ${modernist.bg};
  color: ${modernist.text};
  box-shadow: ${modernist.shadowLg};
  border: 2px solid ${modernist.text};
  font-family: ${modernist.fontBody};
`;

const Header = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
  padding: 24px 32px 16px 32px;
`;

const Eyebrow = styled.div`
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: ${modernist.neutral600};
`;

const Title = styled.h1`
  margin: 6px 0 0 0;
  font-family: ${modernist.fontHeading};
  font-weight: 800;
  font-size: 34px;
  line-height: 1.05;
  letter-spacing: -0.02em;
`;

const CloseButton = styled.button`
  width: 40px;
  height: 40px;
  display: grid;
  place-items: center;
  background: transparent;
  border: 2px solid ${modernist.text};
  color: ${modernist.text};
  cursor: pointer;
  padding: 0;

  &:hover {
    background: ${modernist.accent};
    border-color: ${modernist.accent};
    color: #fff;
  }
`;

const Tabs = styled.div`
  display: flex;
  gap: 32px;
  padding: 0 32px;
  border-bottom: 2px solid ${modernist.text};
`;

const Tab = styled.button`
  appearance: none;
  background: transparent;
  border: 0;
  border-bottom: 4px solid ${(props) => (props.$active ? modernist.accent : 'transparent')};
  margin-bottom: -2px;
  padding: 10px 0 12px 0;
  font-family: ${modernist.fontHeading};
  font-weight: ${(props) => (props.$active ? 800 : 700)};
  font-size: 15px;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: ${(props) => (props.$active ? modernist.text : modernist.neutral600)};
  opacity: ${(props) => (props.$disabled ? 0.45 : 1)};
  cursor: ${(props) => (props.$disabled ? 'not-allowed' : 'pointer')};
`;

const Add = ({
  visible,
  setVisible,
  preSelectData = {},
  preSelectPage = 'main',
  preSelect = 0
}) => {
  const [data, setData] = useState(preSelectData),
    [page, setPage] = useState(preSelectPage),
    [selected, setSelected] = useState(preSelect),
    { t } = useTranslation();

  const mainPages = [
    <PostDetails data={data} setData={setData} handleClose={() => setVisible(false)} />,
    <Live isCurrent={page} closeModal={() => setVisible(false)} />,
    <Shoutout data={data} setData={setData} handleClose={() => setVisible(false)} />
  ];

  useEffect(() => {
    setData(preSelectData);
  }, [selected]);

  useEffect(() => {
    setSelected(preSelect);
    setPage(preSelectPage);
  }, [visible]);

  function getTitleText() {
    switch (page) {
      case 'shoutoutGame':
        return 'add.addShoutout';
      default:
        return 'common.addNew';
    }
  }

  const tabs = [
    { label: t('common.post'), disabled: false },
    { label: t('common.goLive'), disabled: true },
    { label: t('common.shoutOut'), disabled: false }
  ];

  return (
    <Modal
      visible={visible}
      closeModal={() => setVisible(false)}
      selfContent
      modalBg={modernist.backdrop}
      noOutsideClick
    >
      <Card>
        <Header>
          <div>
            <Eyebrow>Playaz4Playaz</Eyebrow>
            <Title>{t(getTitleText())}</Title>
          </div>
          <CloseButton type="button" aria-label="Close" onClick={() => setVisible(false)}>
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="square"
            >
              <path d="M18 6 6 18" />
              <path d="m6 6 12 12" />
            </svg>
          </CloseButton>
        </Header>

        {(page === 'main' || page === 'shoutoutGame') && (
          <Tabs>
            {tabs.map((tab, i) => (
              <Tab
                key={tab.label}
                type="button"
                $active={selected === i}
                $disabled={tab.disabled}
                onClick={() => !tab.disabled && setSelected(i)}
              >
                {tab.label}
              </Tab>
            ))}
          </Tabs>
        )}

        {page === 'main' && mainPages[selected]}

        {page === 'shoutoutGame' && mainPages[selected]}
      </Card>
    </Modal>
  );
};

export default Add;
